export default __webpack_public_path__ + "static/video-e8e3500bc0330a872d36064a1e66f5e4.mp4";